export const WHATS_NEW_CAROUSEL_FIELD_LABELS = {
  ctaLabel: 'CTA Label',
  ctaUrl: 'CTA URL',
  description: 'Description',
  enabledRegions: 'Enabled Regions',
  endAt: 'Ends At',
  imageId: 'Image ID',
  imageOptionsFit: 'Image Fit',
  openInNewTab: 'Open in New Tab',
  optimizelyFeatureFlag: 'Optimizely Feature Flag',
  overline: 'Tag',
  startAt: 'Starts At',
  title: 'Title',
} as const;

export const WHATS_NEW_CAROUSEL_CTA_URL_HELPER_TEXT =
  'External: full https:// URL.\nInternal: start with / (region prefix such as /au/ is allowed).';

export const WHATS_NEW_CAROUSEL_ENABLED_REGIONS_HELPER_TEXT = 'Leave empty for all site regions';

export const WHATS_NEW_CAROUSEL_OPEN_IN_NEW_TAB_HELPER_TEXT =
  'When enabled, the CTA opens in a new browser tab. Typically used for external partner URLs.';

export const WHATS_NEW_CAROUSEL_OPTIMIZELY_FEATURE_FLAG_HELPER_TEXT =
  'Optional. When set, the card is only shown when this Optimizely feature flag is enabled.';

export type WhatsNewCarouselFieldLabelKey = keyof typeof WHATS_NEW_CAROUSEL_FIELD_LABELS;

export function fieldLabel(field: WhatsNewCarouselFieldLabelKey): string {
  return WHATS_NEW_CAROUSEL_FIELD_LABELS[field];
}
